// "Today" home (IA §7.1; layout per D-038): the home dashboard (greeting, "Get your shop ready",
// KPI cards, ranking, hourly and weekly charts, the "needs you" queue), then the customizable widget
// area. D-106: the old static "Launch list" (its "done" steps were hard-coded, so it said "3 of 11,
// Next: Add your first product" to a shop with products and orders) is gone; "Get your shop ready"
// reads the shop's real state.
import { TID } from "../testids";
import { TodayWidgets } from "../analytics/Widgets";
import { HomeDashboard } from "./HomeDashboard";

export function TodayPage() {
  return (
    <div data-testid={TID.todayPage} className="flex flex-col gap-4">
      <HomeDashboard />
      {/* ANALYTICS-01 widget area (P7-C): per-user layout of report widgets. */}
      <TodayWidgets />
    </div>
  );
}
